import BaseModel from "./BaseModel";
import {action, computed, makeObservable, observable} from "mobx";
import AttendanceQuery from './AttendanceQuery'
import {post} from '../common/requester'
import Schedule from './Schedule'


export default class Attendance extends BaseModel {
    constructor(store) {
        super(store);
        makeObservable(this, {
            query: observable,
            items: observable,
            company_id: observable,
            search: action,
            getAttendanceDetail: action,
            details: observable,
        })
    }
    
    query = new AttendanceQuery()
    items = []
    company_id = 0
    details = {}
    
    async search() {
        const res = await post('team/trainings/attendance', {query: this.query.toJson()}).catch((err) => console.error('--attendance error', err))
        if (res) {
            this.query.fromJson(res)
            this.setProperty('items', res.items)
        }
    }
    
    async getAttendanceDetail(id) {
        const res = await post('team/trainings/attendance/detail', {company_user_id: id, query: this.query.toJson()}).catch((err) => console.error('--attendance detail error', err))
        if (res) {
            this.setProperty('details', res.details)
        }
    }
}